<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-data-table :headers="headers" :items="inv_finance_approving_authority_list" dense class="elevation-1 mytable" :search="search">
            <template v-slot:top>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Inventory Finance Approving Authority</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field>
                    <span style="width: 20px;"></span>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="mb-2 button" small v-on="on">Add Inventory Finance Approving Authority</v-btn>
                        </template>
                        <v-card>
                            <v-form v-model="valid">
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field
                                                    v-model="editedItem.name"
                                                    persistent-hint
                                                    :hint="editedIndex==-1?'For example :: Finance Officer , Accounts Head':'For example ::Finance Officer , Accounts Head'"
                                                    label="Enter Inventory Finance Approving Authority Name"
                                                    :rules="[v => !!v || 'required']"
                                                    rounded
                                                    outlined
                                                    dense
                                                >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                                    <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
                <br>
            </template>

            <template v-slot:[`item.isactive`]="{ item }">
                <span v-if="item.isactive">
                    <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <div>
                    <v-avatar style="" size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                    </v-avatar>
                </div>
            </template>
        </v-data-table>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            valid: false,
            overlay: false,
            errorMsg: {
                castId: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Name",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Is Active?",
                    align: "left",
                    sortable: false,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            inv_finance_approving_authority_list: [],
            editedIndex: -1,
            editedItem: {
                id: "",
                name: "",
                isActive: true,
            },
            defaultItem: {
                id: "",
                name: "",
                isActive: true,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Inventory Finance Approving Authority" : "Edit Inventory Finance Approving Authority";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.castId = false;
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/Inventory/getInventoryFinanceApprovingAuthorityList")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                                this.overlay = false;
                                this.inv_finance_approving_authority_list = res.data.inv_finance_approving_authority_list;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log("Errro------>" + error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.inv_finance_approving_authority_list.indexOf(item);
                this.dialog = true;
                this.editedItem.name = item.name;
                this.editedItem.isActive = item.isactive;
                this.editedItem.id = item.id;
            },
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/Inventory/editInventoryFinanceApprovingAuthority", this.editedItem)
                            .then((res) => {
                                if (res.data.flag == "YES") {
                                    Object.assign(this.inv_finance_approving_authority_list[this.editedIndex], this.editedItem);
                                    this.showSnackbar("#4caf50", "Updated Successfully..."); // show snackbar on success
                                    this.onLoad();
                                } else if (res.data.flag == "No") {
                                    this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar on error
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                } else {
                    axios
                        .post("/Inventory/saveInventoryFinanceApprovingAuthority", this.editedItem) 
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.inv_finance_approving_authority_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Added Successfully..."); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.flag == "No") {
                                this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.id) {
                    return true;
                } else {
                    if (!this.editedItem.id) {
                        this.errorMsg.id = true;
                    }
                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
